import Model from './model.js';
import axios from 'axios';
import validate from 'validate.js';

export default class BatchPaymentConfig extends Model {
    urlRoot() { return '/BatchPaymentConfigs'; }

    defaults() {
        return {
            isCreditingDateRequired: false,
            settings: {}
        };
    }

    constraints() {
        return {
            payrollId: {presence: {message: '^Payroll is required'}},
            // todo validate that the bank account supports bulk payments
            bankAccountId: {presence: {message: '^Bank account is required'}},
            settings: {batchPaymentSettings: true},
            isCreditingDateRequired: {presence: true}
        };
    }

    settingsConstraints() {
        return {
            creditingDate: {presence: {message: '^Crediting date is required'}}
        };
    }

    constructor() {
        super(...arguments);
        this.softDelete = false;
    }

    initialize(attrs, {bankAccount = null} = {}) {
        this.idAttribute = 'objectId';
        super.initialize(...arguments);
        this.bankAccount = bankAccount;
        return this;
    }

    set(attr, value, options = false) {
        let changes = {};
        let settings = this.get('settings') || {};

        if (typeof attr === 'string') {
            changes[attr] = value;
        }

        if (typeof attr === 'object' && attr) {
            changes = attr;
            options = value || {};
        }

        if (options && options.force === true) {
            return super.set(...arguments);
        }

        Object.keys(changes).forEach(key => {
            if (typeof this.constraints()[key] === 'undefined') {
                settings[key] = changes[key];
                delete changes[key];
            }
        });
        changes.settings = settings;

        return super.set(changes, options);
    }

    get(attr, options) {
        let settings = super.get('settings') || {};

        if (options && options.force === true) {
            return super.get(...arguments);
        }

        if (typeof this.attributes[attr] !== 'undefined') {
            return super.get(...arguments);
        }

        if (typeof settings[attr] !== 'undefined') {
            return settings[attr];
        }

        return super.get(...arguments);
    }

    validate(attributes) {
        const r = super.validate(...arguments);
        if (r !== false) { // if not valid
            return r;
        }

        const accountId = attributes.bankAccountId;
        if (!accountId) {
            return r;
        }

        const constraints = (this.isCreditingDateRequired()) ?
            this.settingsConstraints() : null;
        if (!constraints) {
            return r;
        }

        return validate(attributes.settings, constraints);
    }

    getBankAccount() {
        return this.bankAccount;
    }

    isCreditingDateRequired() {
        // can't tell without a bankAccount, we default to false
        if (!this.bankAccount) {
            return false;
        }

        return ['08', '18', '22', '26', '27', '29', '33', '35'].includes(
            this.bankAccount.get('bankBnmCode')
        );
    }

    static isBankSupported(bankAccountId) {
        const baseUrl = new BatchPaymentConfig({}).baseUrl();
        return axios.get(
            `${baseUrl}/isBankSupported/${bankAccountId}`, {
                headers: {'Authorization': app.user.getAccessToken().id}
            }
        ).then(r => r.data)
        .catch(err => {
            throw err.response.data.error;
        });
    }
}



// WEBPACK FOOTER //
// ./app/new-models/batch-payment-config.js